import BaseListPage from "../../../../../base/BaseListPage";
import withRouter from "../../../../../utils/withRouter";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import PageContainer from "../../../../../components/PageContainer/PageContainer";
import Search from "../../../../../components/Search";
import Table from "../../../../../components/Table";
import BillingLogsListPresenter from "./BillingLogsListPresenter";
import { formatDateTime } from "../../../../../utils/dateFormat";
import CustomFilterGenerator from "../../../../../components/CustomFilterGenerator/CustomFilterGenerator";
import DateRange from "../../../../../components/DateRange";

class BillingLogsListPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new BillingLogsListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      upsertUseCase(),
      deleteObjectUseCase()
    );

    this.fieldsToDisplay = ["user", "createdAt", "credit"];
  }

  componentDidMount() {
    this.presenter.componentDidMount();
  }

  getCollectionName() {
    return "billing_logs";
  }

  onClickDeleteItem(index) {
    this.presenter.onClickDeleteItem(index);
  }

  formatObjects(objects) {
    return objects.map((object) => {
      return {
        ...object,
        client: object.user.affiliate?.name,
        user: `${object.user.firstName || ""} ${object.user.middleName || ""} ${
          object.user.lastName || ""
        }`,
        createdAt: formatDateTime(object.createdAt),
      };
    });
  }

  formatFields(fields) {
    return {
      client: {
        type: "String",
        label: "Client",
      },
      ...fields,
      createdAt: {
        ...fields.createdAt,
        type: "String",
      },
      user: { ...fields.user, type: "String" },
    };
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count } = this.state;

    return (
      <PageContainer
        title="Billing Logs"
        infiniteScroll={{
          loadMore: this.loadMore.bind(this),
          hasMore: !loading && count > objects.length,
        }}
      >
        <div
          className="d-flex w-100"
          style={{
            width: "100%",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Search
            schemas={this.getSchemas()}
            className="w-50"
            onSubmit={this.searchSubmit.bind(this)}
            fields={schema.fields}
          />
          <DateRange
            field="createdAt"
            onChange={this.onChangeDate.bind(this)}
          />
        </div>
        <Table
          fields={this.formatFields(schema.fields)}
          objects={this.formatObjects(objects)}
          progress={loading}
          excludeFields={Object.keys(schema.fields).filter(
            (key) => !this.fieldsToDisplay.includes(key)
          )}
        />
      </PageContainer>
    );
  }
}

export default withRouter(BillingLogsListPage);
